module.exports = __webpack_public_path__ + "public/img/content.82e4f806.png";